<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    placeholder?: string
    rows?: number
    disabled?: boolean
    autoResize?: boolean
  }>(),
  { rows: 3, autoResize: true },
)

defineEmits<{
  'update:modelValue': [value: string]
}>()

const el = ref<HTMLTextAreaElement | null>(null)

function resize() {
  if (!props.autoResize || !el.value) return
  el.value.style.height = 'auto'
  el.value.style.height = `${el.value.scrollHeight}px`
}

onMounted(resize)
watch(() => props.modelValue, resize)
</script>

<template>
  <textarea
    ref="el"
    :value="modelValue"
    :rows="rows"
    :placeholder="placeholder"
    :disabled="disabled"
    class="w-full bg-surface-container-high text-on-surface font-mono text-sm px-3 py-2 border border-border rounded focus:outline-none focus:ring-1 focus:ring-primary/30 placeholder:text-outline/50 disabled:opacity-40 disabled:cursor-not-allowed resize-none transition-shadow"
    @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value); resize()"
  />
</template>
